// Task 5.11 — renders the `<sup class="cite" data-n="n">` nodes produced by
// remarkCitations.ts. react-markdown passes hProperties through with their
// literal key, so a "data-n" hProperty arrives as the bracket-accessed prop
// `props["data-n"]`, not a camelCase `dataN`.
interface Props {
  "data-n"?: string;
  onSelect?: (n: number) => void;
  children?: React.ReactNode;
}

export default function CitationChip(props: Props) {
  const n = Number(props["data-n"]);
  if (!Number.isFinite(n)) {
    // Not one of ours (schema also allows plain <sup> from other markdown,
    // e.g. footnotes) — render it unmodified.
    return <sup>{props.children}</sup>;
  }
  return (
    <sup
      className="cite"
      data-n={n}
      role="button"
      tabIndex={0}
      onClick={() => props.onSelect?.(n)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") props.onSelect?.(n);
      }}
    >
      {n}
    </sup>
  );
}
